import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=feb49b86&scoped=true&"
import script from "./MainFooter.vue?vue&type=script&lang=js&"
export * from "./MainFooter.vue?vue&type=script&lang=js&"
import style0 from "./MainFooter.vue?vue&type=style&index=0&id=feb49b86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb49b86",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/main_footer.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fcommons%2FMainFooter.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports